import { useEffect } from "react"
import Script from "next/script"

const manageClarityConsent = () => {
  if (typeof window === "undefined" || !window.Cookiebot || !window.clarity) return
  if (window.Cookiebot.consent.statistics) {
    window.clarity("consent")
    window.clarity("start")
  } else {
    window.clarity("consent", false)
    window.clarity("stop")
  }
}

const CookieBot = () => {
  useEffect(() => {
    window.addEventListener("CookiebotOnAccept", manageClarityConsent)
    window.addEventListener("CookiebotOnDecline", manageClarityConsent)
    return () => {
      window.removeEventListener("CookiebotOnAccept", manageClarityConsent)
      window.removeEventListener("CookiebotOnDecline", manageClarityConsent)
    }
  }, [])

  if (process.env.NODE_ENV === "development") return null

  if (!process.env.NEXT_PUBLIC_COOKIEBOT_ID) {
    console.warn("CookieBot ID not set. CookieBot will not be loaded.")
    return null
  }

  return (
    <Script
      id="Cookiebot"
      src="https://consent.cookiebot.com/uc.js"
      data-cbid={process.env.NEXT_PUBLIC_COOKIEBOT_ID}
      type="text/javascript"
      strategy="beforeInteractive"
    />
  )
}

export default CookieBot
